import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  <path
    transform='translate(-3 -3)'
    d='M41.9,161.1L246.6,254c6,2.7,12.7,2.7,18.7,0l204.7-92.9c14.5-6.6,14.5-28.6,0-35.2L265.4,33c-5.9-2.7-12.8-2.7-18.7,0 L41.9,125.9C27.4,132.5,27.4,154.5,41.9,161.1z M470.1,238.7L419,215.5L277,279.9c-6.6,3-13.7,4.5-21,4.5s-14.3-1.5-21-4.5 L93,215.5l-51.1,23.1c-14.5,6.6-14.5,28.6,0,35.2l204.7,92.8c6,2.7,12.7,2.7,18.7,0l204.7-92.8 C484.6,267.3,484.6,245.3,470.1,238.7L470.1,238.7z M470.1,351L419.2,328L277,392.4c-6.6,3-13.7,4.5-21,4.5s-14.3-1.5-21-4.5 L92.8,328L41.9,351c-14.5,6.6-14.5,28.6,0,35.2L246.6,479c6,2.7,12.7,2.7,18.7,0l204.7-92.8C484.6,379.6,484.6,357.6,470.1,351z'
  />,
  'MapLayerRounded'
);

const MapLayerRoundedIcon = function (props) {
  return <SvgIcon viewBox='0 0 512 512' {...props} />;
};

export default memo(MapLayerRoundedIcon);
